import publicUrls from "../../../routes/publicUrls";
import React, { useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import CircularProgress from "@mui/material/CircularProgress";
import SearchAuction from "./SearchAuction";

export default function ExhibitionDetails() {
  const isDesktop = useMediaQuery("(min-width:1000px)");
  const { id } = useParams();
  const [pageNumber, setPageNumber] = useState(1);
  const [search] = useState("");
  const [searchCat] = useState();

  const { lotdata, hasMore, loading, error } = SearchAuction(
    pageNumber, id, search, searchCat
  );

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (loading || error) return;
      if (observer.current) observer.current.disconnect();
      
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore && !error) {
          setPageNumber((prev) => prev + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore, error]
  );

  const gotSinglePage = (id, group, title) => {
    const cleanTitle = (title || "untitled").replace(/[^a-zA-Z0-9-_]/g, "");
    window.location.href = publicUrls.privateSale(group, id, cleanTitle);
  };

  return (
    <section style={{ 
      backgroundColor: "#fff", 
      padding: isDesktop ? "100px 0" : "40px 0", // Mas malawak na padding
      minHeight: "100vh",
      fontFamily: "'Baskerville', 'Playfair Display', serif"
    }}>
      <div className="container-fluid" style={{ maxWidth: "1600px", padding: "0 4%" }}>
        <div className="row g-5"> 
          {lotdata.map((value, i) => {
            const isLastElement = lotdata.length === i + 1;
            const imageUrl = value.image?.[0]?.img_url || "https://placehold.co/600x800?text=No+Image";

            return (
              <div 
                key={`${value.data.id}-${i}`}
                ref={isLastElement ? lastBookElementRef : null}
                className="col-xl-3 col-lg-4 col-md-6 col-sm-12"
                style={{ marginBottom: "80px" }} // Increased margin for "breathing room"
              >
                <div 
                  onClick={() => gotSinglePage(value.data.id, value.data.privateSalesGroup, value.data.title)}
                  className="art-card-container"
                >
                  
                  <div className="image-frame">
                    <img
                      src={imageUrl}
                      alt={value.data.title}
                      className="art-image"
                    />
                  </div>

                  
                  <div className="art-metadata">
                    <h4 className="artist-name">
                      {value.data.artist || "Anonymous"}
                    </h4>
                    <h3 className="artwork-title">
                      {value.data.title}
                    </h3>
                    <div className="divider"></div>
                    
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        

        {loading && (
          <div style={{ display: "flex", justifyContent: "center", padding: "80px" }}>
            <CircularProgress size={24} sx={{ color: "#1a1a1a" }} thickness={2} />
          </div>
        )}

{(error || (!hasMore && lotdata.length > 0)) && (
  <div className="row">
    <div className="col-12">
      <div className="end-of-results" style={{textAlign: 'center'}}>
        <div className="line"></div>
        <span className="text">End of Collection</span>
        <div className="line"></div>
      </div>
    </div>
  </div>
)}

        {!loading && lotdata.length === 0 && !error && (
          <div style={{ textAlign: "center", padding: "150px 0" }}>
            <p style={{ letterSpacing: "3px", textTransform: "uppercase", fontSize: "14px", color: "#999" }}>
              No works currently on display.
            </p>
          </div>
        )}
      </div>

      <style>
        {`
          .art-card-container {
            cursor: pointer;
            group: hover;
          }

          .image-frame {
            overflow: hidden;
            background-color: #fcfcfc;
            aspect-ratio: 4/5;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 30px;
            transition: background-color 0.4s ease;
          }

          .art-card-container:hover .image-frame {
            background-color: #f2f2f2;
          }

          .art-image {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            transition: transform 0.8s cubic-bezier(0.25, 1, 0.5, 1);
          }

          .art-card-container:hover .art-image {
            transform: scale(1.03);
          }

          .art-metadata {
            padding: 20px 0;
            text-align: left;
          }

          .artist-name {
            font-family: 'Helvetica', 'Arial', sans-serif;
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 2px;
            color: #1a1a1a;
            margin-bottom: 8px;
            font-weight: 700;
          }

          .artwork-title {
            font-family: 'Playfair Display', 'Baskerville', serif;
            font-size: 20px;
            font-style: italic;
            color: #1a1a1a;
            margin: 0 0 12px 0;
            line-height: 1.3;
            font-weight: 400;
          }

          .divider {
            width: 30px;
            height: 1px;
            background-color: #e0e0e0;
            margin-bottom: 12px;
            transition: width 0.4s ease;
          }

          .art-card-container:hover .divider {
            width: 100%;
            background-color: #b5835a;
          }

          .lot-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .lot-number {
            font-size: 12px;
            color: #888;
            font-family: 'Helvetica', sans-serif;
          }

          .view-details {
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 1px;
            color: #b5835a;
            font-weight: 600;
            opacity: 0;
            transform: translateX(-10px);
            transition: all 0.4s ease;
          }

          .art-card-container:hover .view-details {
            opacity: 1;
            transform: translateX(0);
          }

          .end-of-results {
            display: flex;
            align-items: center;
            justify-content: center;
      
            padding: 100px 0;
          }

          .end-of-results .line {
            height: 1px;
            background: #eee;
            flex-grow: 1;
            max-width: 100px;
          }

          .end-of-results .text {
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 4px;
            color: #bbb;
          }
        `}
      </style>
    </section>
  );
}